import MobileMenuBottom from './MobileMenuBottom';

export default MobileMenuBottom;
